<mat-form-field class="mat-form-field-search" [class.is-handset]="isHandset">
    <mat-icon matPrefix (click)="search()">search</mat-icon>
    
    <input [title]="placeholder | translate | ucfirst" matInput [(ngModel)]="searchInput" [disabled]="!placeholder"
        type="text" [placeholder]="placeholder | translate | ucfirst" (keyup.enter)="search()">
    <button *ngIf="searchInput" mat-icon-button matSuffix (click)="clear()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>